import React, { Component} from 'react';
import * as scriptUtils from './utils/scriptUtils';
import './ChatChannel.css';
import UserBadge from './UserBadge';
import donationbadge from './donationbadge.gif';
import attendancebadge from './attendancebadge.gif';

const processString = require('react-process-string');

let linkifyConfig = [{
    regex: /(http|https):\/\/(\S+)\.([a-z]{2,}?)(.*?)( |\,|$|\.)/gim,
    fn: (result) => <span>
						<a className="hypeshot-chatChannelMessageLink" target="_blank" href={`${result[1]}://${result[2]}.${result[3]}${result[4]}`}>{result[2]}.{result[3]}{result[4]}</a>{result[5]}
					</span>
}, {
    regex: /(\S+)\.([a-z]{2,}?)(.*?)( |\,|$|\.)/gim,
    fn: (result) => <span>
						<a className="hypeshot-chatChannelMessageLink" target="_blank" href={`http://${result[1]}.${result[2]}${result[3]}`}>{result[1]}.{result[2]}{result[3]}</a>{result[4]}
					</span>
}];

class ChatChannelMessage extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		let messageInfo = this.props.messageInfo;
		let message = this.props.message;
		let name = messageInfo["name"];
		let profileImage = messageInfo["profileImage"];
		let time = messageInfo["time"];
		let badgeInfo = messageInfo["badgeInfo"];
		let isNFTPFP = messageInfo["isNFTPFP"];
		let isRepeatAttendee = "minutesAttended" in badgeInfo && Object.keys(badgeInfo["minutesAttended"]).length > 1;
		let hasMadeMicropayment = "micropayments" in badgeInfo && Object.keys(badgeInfo["micropayments"]).length > 0;

		return (
			<div className="flex items-stretch ml-4 scrollbar-hide">
				<div className="flex w-10 h-10 rounded-full">
					{
						isNFTPFP
							?
						<div className="nftImageChatContainer">
							<img className="nftPFP" alt="Chat profile" src={profileImage} />
						</div>
							:
						<img className="flex w-10 h-10 rounded-full" alt="Chat profile" src={profileImage} />
					}
				</div>
				<div className="flex flex-col mx-4 mb-4 w-[220px]">
					<div className="hypeshot-chatChannelMessageInfo">
						<div className="hypeshot-chatChannelMessageLeftHalf">
							<div className="text-white font-bold text-sm mr-2">
								{name}
							</div>
							{
								isRepeatAttendee
									?
								<div>
									<div className="userBadgeRepeat">
                    <img
                      src={attendancebadge}
                    />
  									<div className="tooltiptext">
  										Attended multiple livestreams
  									</div>
                  </div>
								</div>
									:
								null
							}
							{
								hasMadeMicropayment
									?
                <div>
									<div className="userBadgeDonation">
                    <img
                      src={donationbadge}
                    />
  									<div className="tooltiptext">
  										Has donated
  									</div>
                  </div>
								</div>
									:
								null
							}
						</div>
					</div>
					{
						this.props.username != null && name == this.props.username
							?
						<div className="text-gray-300 font-normal mr-2 text-sm break-words max-w-[200px]">
							{processString(linkifyConfig)(message)}
						</div>
							:
						<div className="text-gray-300 font-normal mr-2 text-sm break-words max-w-[200px]">
							{processString(linkifyConfig)(message)}
						</div>
					}
					<div className="hypeshot-chatChannelMessageTime">
						{time}
					</div>
				</div>
			</div>
		);
	}
}

export default ChatChannelMessage;
